import apiClient from '../apiClient';
import { trackPromise } from 'react-promise-tracker';
import { offlineGet } from '../helpers/offlineHelpers';

async function listDefectypes() {
    return trackPromise(apiClient.get('/api/defectType/getAll'));
}

async function listEnabledDefectTypes() {
    // const { data } = await trackPromise(apiClient.get('/api/defectType/getAllActive'));
    // return data?.data ?? [];
    return trackPromise(
        offlineGet(
            'defect-types-enabled',
            () => apiClient.get('/api/defectType/getAllActive'),
            (res) => res.data?.data ?? []
        )
    );
}

async function getDefectTypeById(id) {
    const { data } = await trackPromise(apiClient.get(`/api/defectType/getById/${id}`));
    return data?.data ?? null;
}

async function createDefectType(payload) {
    return await trackPromise(apiClient.post('/api/defectType/add/', payload));
}

async function updateDefectType(id, payload) {
    return await trackPromise(apiClient.put(`/api/defectType/updateById/${id}`, payload));
}

async function toggleDefectType(id) {
    return await trackPromise(apiClient.put(`/api/defectType/enabledDisable/${id}`));
}

const defectTypeService = {
    listDefectypes,
    listEnabledDefectTypes,
    getDefectTypeById,
    createDefectType,
    updateDefectType,
    toggleDefectType
};

export default defectTypeService;
